// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const DepartmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DepartmentTitle = styled.span`
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-size: 14px;
  font-weight: 700;
  color: #000000;
  display: block;
`;

export const Department = styled.div`
  display: grid;
  align-items: center;
  padding: 10px 0;
  grid-auto-columns: ${(props) => (props.isQuickView ? `85px` : `100px`)};
  gap: ${(props) => (props.isQuickView ? `0` : `10px`)};
  grid-auto-flow: column;
  overflow: scroll;
  white-space: nowrap;
  place-items: center;
  &::-webkit-scrollbar {
    display: none;
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    grid-auto-columns: 85px;
    gap: 0;
  }
`;

export const DepartmentItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
`;
export const DepartmentImageWrapper = styled.div`
  border-radius: 50%;
  border: 1px solid ${(props) => (props.active ? '#254f6e' : '#9b9b9b')};
`;

export const DepartmentImage = styled.img`
  width: ${(props) => (props.isQuickView ? `40px` : `50px`)};
  height: ${(props) => (props.isQuickView ? `40px` : `50px`)};
  padding: ${(props) => (props.isQuickView ? `12px` : `20px`)};
  ${(props) =>
    props.active
      ? `
    filter: invert(21%) sepia(59%) saturate(2552%) hue-rotate(200deg) brightness(87%) contrast(108%);
    `
      : ``};

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    width: 40px;
    height: 40px;
    padding: 12px;
  }
`;
export const DepartmentName = styled.span`
  margin-top: 10px;
  font-size: 14px;
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-weight: 700;
  color: ${(props) => (props.active ? '#254f6e' : '#9b9b9b')};
`;
